var _defs, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _rect, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideMaterial4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 567.18 409.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#812990;}.cls-3{fill:#6b7b84;}.cls-4{fill:#231f20;}.cls-5,.cls-6{fill:none;stroke-miterlimit:10;stroke-width:0.25px;}.cls-5{stroke:#ffcb05;}.cls-6{stroke:#6b7b84;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 463.7,
    y1: 349.69,
    x2: 566.71,
    y2: 349.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d60f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#812990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "566.71 392.61 515.2 306.77 463.69 392.61 566.71 392.61"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70,360.66l-1,.14a3.42,3.42,0,0,1-.48.11c-.38,0-.57-.47-1.09-.58-.13,0,0,0-.2-.06s.07,0-.24-.12c0,.34-.08.24-.08.51a2,2,0,0,0,.22.89c.09.19.14.12.13.4a1.67,1.67,0,0,0,.15,1.11,3,3,0,0,1,.38.79c.51,0,.44,0,.5.15.49,0,.17-.11.44-.15,0,0,.49.12.37-.5.36.09.19.29.42.26s.1-.18.13-.4-.09-.06.25-.22l-.08-.44c0-.51.12,0,.29.07l.22-1.53c0-.12.16-.07-.14-.5C69.89,360.63,70.08,360.64,70,360.66Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.14,359.36c0,.2.12.12-.14.14l.29.65c.13-.07.09,0,.29-.07,0-.44,0-.28-.15-.51S70.34,359.4,70.14,359.36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.5,358.77c-.07.3,0,0-.09.24s-.13.65.31.41C66.72,358.91,66.77,359,66.5,358.77Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.9,353.62a2.56,2.56,0,0,0-.89.14c-.54.14-.3.26-.13.51a3.18,3.18,0,0,0,1.26-.18c.24,0,.26,0,.12-.26H60.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.63,350.05c0-.08,0-.16-.06-.25l-.83-.3c-.6-.22-1.19-.44-1.76-.67s-1.19-.49-1.86-.82-1.41-.71-2.14-1.17a4.82,4.82,0,0,1-1.77-2,5.74,5.74,0,0,1-.4-1h-.14a4,4,0,0,0-.8.11l-.75.19a9.87,9.87,0,0,1-2,.39h-.27c-.25,0-.51,0-.77,0a4.91,4.91,0,0,1-.57,0,9.11,9.11,0,0,1-1.22-.22l-.43-.09-.33.39a1.42,1.42,0,0,1,.22.2,1.48,1.48,0,0,1,.31,1.43,2.19,2.19,0,0,1-1.9,1.4c-.24,0-.47,0-.7,0h-.11a2.28,2.28,0,0,1-1.87-1.22,1.66,1.66,0,0,1,.13-1.83l0-.05q.14-.23.3-.45a4.28,4.28,0,0,0,.34-.54l.19-.38a2.5,2.5,0,0,1-2.1-1.58A5.38,5.38,0,0,1,54,340l-.21.05-.34.09a2.23,2.23,0,0,1-.29.31,1.84,1.84,0,0,1-1.29.61,1.81,1.81,0,0,1-.51-.08h-.08a1.74,1.74,0,0,1-1-.3,1.3,1.3,0,0,1-.54-.38,1.27,1.27,0,0,1-.25-1.08,4.62,4.62,0,0,1,.83-1.81l.11-.14a1.67,1.67,0,0,1,.5-1,8.76,8.76,0,0,1,.66-.59l.18-.15a4.1,4.1,0,0,1,.36-.29,2.19,2.19,0,0,1,.35-1,4,4,0,0,1,1.2-1.17c.25-.17.5-.3.74-.44l.37-.2.34-.21.19-.12A1.08,1.08,0,0,1,56,332a1.1,1.1,0,0,1,.47.1,1.15,1.15,0,0,1,.63,1.31l-.37,1.28a2.87,2.87,0,0,1-.54,1,9.35,9.35,0,0,1,.79.54,5.86,5.86,0,0,1,.62.58H58l.17,0a4.12,4.12,0,0,0,1.15-.52l.16-.1a9.72,9.72,0,0,1,2.27-1.08,15.59,15.59,0,0,1,4-.56h.53c.75,0,1.49,0,2.19.08a13.77,13.77,0,0,1,1.67.22,9.72,9.72,0,0,1,4,1.75.74.74,0,0,0-.4-.56c-.21-.1-.1,0-.25-.13l0,0-.16-.13c-.25-.16-.21,0-.31-.35l-.09.05,0,0c-.16.05-.1-.28-.25-.47s.06.14-.31-.05c-.21-.1,0,0-.12-.08s-.06-.05-.15-.08l-.13,0c-.6-.25-.49-.34-.49-.95-.51-.14-.2-.53-.17-.86.06-.54-.26-.6-.13-1.18-.72,0-.43-.71-.63-1.48l0-.7c0-.15,0,.06.08-.21l-.19-.09c-.69-.41-.55-.73-.75-.86l-.5.16c-.15.11,0,.08-.23.13-.48-.45-.25-1.38-.42-2-.06-.26-.11-.61-.46-.7a1.16,1.16,0,0,1,.22-.43c-.17-.09-.26-.07-.43-.15a2.1,2.1,0,0,0-.22-1.16c-.14-.24,0-.26-.37-.29-.08.34,0,.14-.36.29a2.11,2.11,0,0,1-.27,1.12l0,0-.06.08a1.44,1.44,0,0,0-.3.72h.21c0,.33,0,.14-.16.34s-.09,0,0,.36-.26.41-.23.81.12.18.11.44-.08.21-.07.42c0,.54.23.4,0,.92s-.16,1.07-.49,1.61a7,7,0,0,0-.37.79,1,1,0,0,1-.83.32,3.35,3.35,0,0,1-.74-.36.57.57,0,0,1-.31-.26c-.08-.14,0-.09-.08-.21-.17-.36-.66-.33-1-.46s-.47-.62-1.3-1l-.44-.13-.34-.24-.28-.31-.35-.24-.31-.2c-.28-.16-.24,0-.25-.4.16-.05.34-.35.48-.55s0,0,.08-.12l.07-.16s0,0,0-.05l.15-.36c-.3-.12,0,.05-.29-.07.12-.17.09-.08.15-.29.38-.18.28-.08.5,0,.44-.64.19-.24.28-.61s.3-.38.45-.62l-.27-.17c-.3-.16-.23.12-.23-.41a1.3,1.3,0,0,0-.59.43c-.07-.09-.07.15-.07-.21a1.24,1.24,0,0,1-.37.14c.22-.28.12,0,.23-.29a2,2,0,0,0-1,.36c-.18-.13-.29-.11-.36-.36-.36,0-.1,0-.43.15a1.57,1.57,0,0,0-.59-.3v-.14c-.38,0-.64.25-1-.13,0,0-.16-.26-.19-.31-.27.08-.15.08-.37.22a.55.55,0,0,0-.32-.41c-.12-.07,0,0-.15-.05l-.4,0c-.06,0,.1,0-.22.07v.22c.28.06,0,0,.2.08l.06,0,0,0c.22.09.24,0,.58,0a1.7,1.7,0,0,1,.14.66l-.54.18,0,0-.65.08c-.28,0-.18-.07-.29-.28a.87.87,0,0,0-.19.1l-.19.1c-.21.16.11.07-.24.19a.61.61,0,0,1-.33,0c0,.19,0,.18-.16.41s0,.22-.36.25c0,.52.06.22.15.57l-.23.09c-.37.08-.2.08-.32.45s-.31.1-.46.78c.23.16.28.16.33.3a.63.63,0,0,1,0,.27c-.7-.05-.39,0-.64,0a2.88,2.88,0,0,0-.82-.13c0,.54,0,.17-.15.31l0,0-.11.17c0-.5.11-.15.14-.57-.61-.17-.58-.82-1.21-.93s0-.15-.53-.16c-.13.27-.05.32-.29.5.08-.34,0-.11,0-.21-.27.06-.16.07-.36.21-.05-.33-.09-.28-.37-.14.06.22,0,.15.22.22a.79.79,0,0,0-.15.43l-.43-.36c-.19.37,0,.25-.28.45l-.1,0c-.09.06-.11.09-.21.15.11.4.19.08.08.36-.25,0-.27.11-.44.33,0,0,0,0,0,0l0,.06-.12.11c-.1.09-.23.14-.26.36a.55.55,0,0,0,.18.41c-.16.2-.14.13-.15.44l-.32-.1c-.34-.08-.16.18-.26-.11H45c0,.49-.19.37-.08.59s.27.18.44.42c-.18.08-.06.06-.29,0,0,.39.09.13,0,.51-.22-.16-.11-.11-.36-.58s-.27-.16-.23-.65c-.3.08-.28.23-.43.43l-.35.38a1.24,1.24,0,0,0-.29.57c0,.22.13.33.13.72,0,0,0,0,0,.05l.19-.05c0,.16,0,.08-.1.19l-.07.07c-.1.12,0,.05-.11.11l-.12.1,0,0-.09.06c-.18.15-.14.17-.23.37l0,.09c-.44,1.15-.7,1.15-2,1.64-.24.09,0,.06-.27.08s-.19-.17-.49,0,0,.17-.29.36-.41-.11-1.1.58a.59.59,0,0,1-.45.18c-.37,0-.1-.21-.58.11,0-.39.08-.14-.14-.23-.06.24-.05.2-.24.35-.44.33-.09-.1-.72.59l-.07.08-.23.27-.06.09c-.35.38-1.08.22-1.08,1.39h-.22a5.53,5.53,0,0,1-.07-.8,1.66,1.66,0,0,0-.52,1.3c.24.08.07-.12.2.18a1,1,0,0,1-.06.9,1.14,1.14,0,0,0-.14.39v.52c0,.17.07.12.24.32s0,.27.37.64l0,0,.18.26c.29.37.4.18.4,1.05h-.14a1.17,1.17,0,0,0-.81-1c0,.67.18.22.23.72a.56.56,0,0,0-.29-.14c0,.38.06.13-.15.22.47.7,1.21,1,1.39,1.87.07.41.5.62.65,1s0,.05.12.24l.22.21a1,1,0,0,1,.25.63c.25,1.54,1.18,1.86,1.27,2.77l0,.55c-.06.32,0,.26.11.58s0,.43-.1.68a1.68,1.68,0,0,1-.43-.07c0,.52,0,1,.45,1s.82.75,1.83.58a3.72,3.72,0,0,0,1.11-.14c.29-.17.32-.34.43-.46l0,0,.11-.12.06-.07.22-.13c.17,0,.43,0,.51-.25,0,0,0-.12,0-.14.11-.41.68-.4,1.06-.53l.83-.11h.18c.26,0-.08,0,.19,0l.11,0,0,0c.25.12-.2.06.26.09.07-.16.15-.24.61-.23s.85.22,1.09-.76a.72.72,0,0,1,.13-.37c.19-.21.3-.12.59-.29,1.16-.67.71-.79,2-.81a3.89,3.89,0,0,0,1.39-.43c.85-.34.77-.58,2.09-.58a3.51,3.51,0,0,0,.84-.12c.32-.05,1,.46,1.21.62.42-.11.19-.3.71,0a2.52,2.52,0,0,0,.88.2c.1.23,0,0,0,.36.24-.05.24-.09.44,0-.06.16-.14.11-.18.27l.15.42c.18.16.32,0,.5.22s.12.31.39.64a1.18,1.18,0,0,1,.23.71s0,0,0,0h-.07l-.19.19c.44,0,.33.32.72.41.14,0,0,0,.15,0s0,0,.15.06l0-.29c-.06-.22,0-.29.43-.79.26-.34.77-.34,1-.71a2,2,0,0,1,.32-.55c.18-.19,0,.08.16-.2,0,.05,0,0,0,0l.07.09.12.17c-.22,0-.19,0-.29.14.15.33.16.29,0,.49a1.71,1.71,0,0,0-.37,1.14c0,.43-.09.33-.5.33-.07.27-.12.2-.15.51a1.41,1.41,0,0,0,.51-.15c.31-.07.35.17.52-.21l.29-.87.13.22s0,0,0,.05l0,.1,0,0c.41.82-.27.84-.31,1.32a2.54,2.54,0,0,0,.73-.13s0,0,0,0,0,0,0,0c.45.38.93.88.73,1.55,0,0,0,0,0,0l0,.36a1.17,1.17,0,0,0,.31.46l.3.49c.22.25.56.14.81.43l.21.23c.21-.07.21-.16.43-.09l.17.06.06,0c.19.05.1,0,.28.09s.74.41.8.57c.41,0,1.19-1,1.38-.29.37,0,.38-.25.66-.28l-.05.09c-.1.22,0-.13-.1.27l.35.31.1.11.23.08a.6.6,0,0,1,.13.3.35.35,0,0,0,.21-.51c.86,0,1.1-.86,2-.82.59,0,1,.2,1.48-.14l.15-.21c.11-.25,0-.32,0-.54l.39-1.06a1.39,1.39,0,0,1,.77-.93c.21-.18,0-.06.07-.2v0l.05-.19a1.42,1.42,0,0,1,.39-.69c.43-.36.25-.6.89-1.29l.42-.24.05,0,.15-.11C75.82,351.06,75.73,350.55,75.63,350.05Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.59,333.13Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57,337.79a8.26,8.26,0,0,0-.74-.72,10.24,10.24,0,0,0-1.12-.73,1.88,1.88,0,0,0-.57-.22.8.8,0,0,0-.35,0,2.47,2.47,0,0,1,.6-.69,2.12,2.12,0,0,0,.8-1.07c.13-.43.25-.85.37-1.27l0,0-.56.35c-.35.2-.72.38-1.06.6a3,3,0,0,0-.88.85,1.27,1.27,0,0,0-.17.89c0,.21-.1.21-.1.21a1.57,1.57,0,0,0-.65.39c-.26.22-.53.44-.77.68a.7.7,0,0,0-.2.39,1.22,1.22,0,0,1-.3.66,3.36,3.36,0,0,0-.64,1.38c0,.17,0,.24.23.21a.53.53,0,0,0,.58.22s.07,0,.09,0c.37.19.55.15.9-.18a2.18,2.18,0,0,0,.25-.28c.17-.26.46-.29.72-.36a2,2,0,0,0,.9-.36s.2-.17.29-.05a2.49,2.49,0,0,1,.35.47,1.89,1.89,0,0,1,.17.69,4.62,4.62,0,0,0,.26,1.33A1.43,1.43,0,0,0,57,342a2.71,2.71,0,0,1,1.44,0l.28.12-.54,0c-.09,0-.14,0-.18.12-.25.6-.5,1.2-.79,1.78-.19.37-.47.71-.69,1.07s-.33.46-.17.72a1.27,1.27,0,0,0,1,.71l.74,0a1.16,1.16,0,0,0,.86-.64.39.39,0,0,0-.11-.4c-.07.18-.21.21-.37.23a.62.62,0,0,0-.24.1c0-.16.15-.16.29-.2l0-.32-.08.05a.36.36,0,0,1-.49.17l-.2-.07c-.21-.06-.25,0-.27.17a1,1,0,0,1,0,.16.44.44,0,0,1,0-.57c.27-.34.54-.67.84-1A11.14,11.14,0,0,0,60.05,342a1.65,1.65,0,0,0,.16-.42.84.84,0,0,0-.39-.86,7.84,7.84,0,0,0-1-.61.72.72,0,0,1-.44-.86l.09.28c.08.26.32.34.53.45s.67.32,1,.51a1,1,0,0,1,.32,1.61c-.18.27-.35.56-.52.84-.07.11-.07.17.09.2.58.11,1.16.27,1.75.34a8.56,8.56,0,0,0,1.43,0,14.6,14.6,0,0,0,2.61-.55,3.94,3.94,0,0,1,1.53-.09s.07,0,.11,0l-.09-.82c0-.23,0-.45-.07-.68a5.54,5.54,0,0,0-.54-2.22c-.06-.12-.15-.22-.23-.35a1.28,1.28,0,0,1,.5.45,2.72,2.72,0,0,1,.41,1.1c.13.67.21,1.34.33,2a7.41,7.41,0,0,0,.6,2.1,3.7,3.7,0,0,0,1.37,1.56,22.58,22.58,0,0,0,2,1.12c.58.29,1.18.54,1.78.78s1.49.57,2.24.85l1.09.4a.65.65,0,0,1,.43.41l-.59-.3,0,0c.06.21.14.42.18.63.11.56.21,1.13.31,1.7s.15.88.21,1.32c0,.25,0,.49,0,.74a1.57,1.57,0,0,0,.34,1,2.41,2.41,0,0,0,.24.21,7.91,7.91,0,0,1,1.26,1.56,1.2,1.2,0,0,0,.44.4h.35a.17.17,0,0,0,0-.1.4.4,0,0,1,0-.55,2,2,0,0,0,.16-.4c0-.24-.12-.41-.24-.58l-.14-.18-.29.39,0,0a.68.68,0,0,0,.11-.78,1.3,1.3,0,0,0-.49-.66,1.19,1.19,0,0,1-.57-1c-.08-.51-.13-1-.18-1.53a6.8,6.8,0,0,1-.07-.89c0-.43.1-.86.13-1.29a1,1,0,0,0-.26-.7,5.73,5.73,0,0,0-1.19-.88c-.75-.52-1.5-1-2.22-1.6a10.47,10.47,0,0,1-2.43-2.79,3.18,3.18,0,0,1-.41-1.25,2,2,0,0,1,.13-1,4.47,4.47,0,0,0,.25,1.81c.39-.1.74-.25.81-.68a3,3,0,0,0-.06-.78c0-.23.09-.37.33-.32a1.24,1.24,0,0,1,.75.57c.6.89,1.17,1.8,1.75,2.7.35.55.7,1.1,1.06,1.64.5.72,1,1.44,1.52,2.14a11.65,11.65,0,0,0,.92,1.06c.28.32.59.61.89.9a11.21,11.21,0,0,0,2,1.48,10.85,10.85,0,0,0,2.79,1.22,16.39,16.39,0,0,0,2.08.45,9.2,9.2,0,0,0,1.74.11,12.83,12.83,0,0,0,1.84-.22,10.31,10.31,0,0,0,2.75-.95c.42-.21.82-.48,1.23-.73a.18.18,0,0,0,.07-.08c0-.09,0-.19,0-.28s-.17-.05-.24,0-.43.17-.64.27a12.33,12.33,0,0,1-2.34.84,9.19,9.19,0,0,1-1.63.31,12,12,0,0,1-1.8,0,7.48,7.48,0,0,1-3.09-.88,9.35,9.35,0,0,1-2.08-1.45c-.23-.21-.47-.43-.69-.65a15.89,15.89,0,0,1-1.65-2,32.22,32.22,0,0,1-1.74-2.87l-1.16-2.14a21.33,21.33,0,0,0-1.89-3,13.34,13.34,0,0,0-1.5-1.6,8.62,8.62,0,0,0-4.13-2,11,11,0,0,0-1.53-.21c-.87,0-1.75-.09-2.62-.07a14.36,14.36,0,0,0-3.74.52,9.88,9.88,0,0,0-2.19,1.07,5,5,0,0,1-1.47.65,1.83,1.83,0,0,1-.4.05,6.26,6.26,0,0,0-.87,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.5,326.28h-.59v1.66h-.34v-1.66H151v-.34h1.52Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.65,325.94v2h-.35v-1.42l-.66,1-.65-1v1.42h-.35v-2H153l.62,1,.63-1Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.72,331.14v.64a4.42,4.42,0,0,0-1.14-.61,4.21,4.21,0,0,0-1.48-.24,4.43,4.43,0,0,0-1.72.33,4.16,4.16,0,0,0-1.37.91,4.31,4.31,0,0,0-.9,1.35,4.44,4.44,0,0,0,0,3.31,4.43,4.43,0,0,0,.9,1.35,4.16,4.16,0,0,0,1.37.91,4.43,4.43,0,0,0,1.72.33h.17A4.76,4.76,0,0,0,99,339.1v-2.3h0a2.23,2.23,0,0,1-.79.51,2.7,2.7,0,0,1-.94.17,2.56,2.56,0,0,1-.39,0h0a3.41,3.41,0,0,1-.55-.14,2.15,2.15,0,0,1-.79-.51,2.24,2.24,0,0,1,0-3.27,2.41,2.41,0,0,1,.79-.5,2.5,2.5,0,0,1,.94-.18,2.42,2.42,0,0,1,1.73.68,2.17,2.17,0,0,1,.72,1.64v4.24h2v-8.28Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.09,339.42l-4.51-4.35v4.35h-2V327.94h2v4.34L91.09,328H94l-6,5.71,6,5.75Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.05,330.93a3.87,3.87,0,0,1,1.51.29,3.47,3.47,0,0,1,1.16.83,3.68,3.68,0,0,1,.75,1.21,4.1,4.1,0,0,1,.26,1.49v4.67h-2v-4.67a1.71,1.71,0,0,0-.6-1.34,1.92,1.92,0,0,0-1.39-.55,2,2,0,0,0-1.41.55,1.79,1.79,0,0,0-.58,1.34v4.67h-2v-8.27h2v.61a4.42,4.42,0,0,1,1-.6A3.3,3.3,0,0,1,107.05,330.93Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.66,331.15a3.68,3.68,0,0,1,1.37-.24v1.93a2.46,2.46,0,0,0-1.74.68,2.28,2.28,0,0,0-.71,1.65v4.25h-2v-8.28h2v.62A4.72,4.72,0,0,1,134.66,331.15Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.64,330.93a4.57,4.57,0,0,1,1.74.33,4.42,4.42,0,0,1,1.43.91,4.16,4.16,0,0,1,1,1.35,4.09,4.09,0,0,1,0,3.31,4.27,4.27,0,0,1-1,1.35,4.42,4.42,0,0,1-1.43.91,4.78,4.78,0,0,1-3.49,0,4.42,4.42,0,0,1-1.43-.91,4.27,4.27,0,0,1-1-1.35,4.09,4.09,0,0,1,0-3.31,4.16,4.16,0,0,1,1-1.35,4.42,4.42,0,0,1,1.43-.91A4.58,4.58,0,0,1,140.64,330.93Zm0,1.93a2.46,2.46,0,0,0-1.74.68,2.24,2.24,0,0,0,0,3.27,2.15,2.15,0,0,0,.79.51,2.75,2.75,0,0,0,.95.17,2.69,2.69,0,0,0,.93-.17,2.37,2.37,0,0,0,.8-.51,2.24,2.24,0,0,0,0-3.27A2.52,2.52,0,0,0,140.64,332.86Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M150.17,330.93a4.66,4.66,0,0,1,1.75.33,4.49,4.49,0,0,1,1.42.91,4.16,4.16,0,0,1,1,1.35,4.09,4.09,0,0,1,0,3.31,4.27,4.27,0,0,1-1,1.35,4.49,4.49,0,0,1-1.42.91,4.66,4.66,0,0,1-1.75.33,4.58,4.58,0,0,1-1.75-.33,4.53,4.53,0,0,1-1.43-.91,4.43,4.43,0,0,1-1-1.35,4.2,4.2,0,0,1,0-3.31,4.32,4.32,0,0,1,1-1.35,4.53,4.53,0,0,1,1.43-.91A4.58,4.58,0,0,1,150.17,330.93Zm0,1.93a2.42,2.42,0,0,0-1.73.68,2.22,2.22,0,0,0,0,3.27,2,2,0,0,0,.78.51,2.75,2.75,0,0,0,.95.17,2.6,2.6,0,0,0,.93-.17,2.37,2.37,0,0,0,.8-.51,2.24,2.24,0,0,0,0-3.27A2.52,2.52,0,0,0,150.17,332.86Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.38,331.14v.64a4.42,4.42,0,0,0-1.14-.61,4.2,4.2,0,0,0-1.47-.24,4.44,4.44,0,0,0-1.73.33,4.11,4.11,0,0,0-1.36.91,4,4,0,0,0-.9,1.35,4.44,4.44,0,0,0,0,3.31,4.17,4.17,0,0,0,2.26,2.26,4.44,4.44,0,0,0,1.73.33h.17a4.76,4.76,0,0,0,1.74-.32v-2.3h0a2.37,2.37,0,0,1-.8.51,2.64,2.64,0,0,1-1.33.14h0a3.05,3.05,0,0,1-.54-.14,2,2,0,0,1-.79-.51,2.22,2.22,0,0,1,0-3.27,2.22,2.22,0,0,1,.79-.5,2.46,2.46,0,0,1,.94-.18,2.43,2.43,0,0,1,1.73.68,2.2,2.2,0,0,1,.71,1.64v4.24h2v-8.28Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.51,331.14h0v.63a4.42,4.42,0,0,0-1.14-.61,3.34,3.34,0,0,0-.74-.19,4.79,4.79,0,0,0-.87-.07,4.25,4.25,0,0,0-1.69.33,3.89,3.89,0,0,0-1.33.91,4.23,4.23,0,0,0-.85,1.36,4.34,4.34,0,0,0-.31,1.66h0a4.37,4.37,0,0,0,.32,1.65,4.43,4.43,0,0,0,.9,1.35,4.16,4.16,0,0,0,1.37.91,4.43,4.43,0,0,0,1.72.33h.3a4.76,4.76,0,0,0,1.61-.32v-2.3h0a2.23,2.23,0,0,1-.79.51,2.7,2.7,0,0,1-.94.17,2.56,2.56,0,0,1-.39,0h0a3.41,3.41,0,0,1-.55-.14,2.15,2.15,0,0,1-.79-.51,2.24,2.24,0,0,1-.54-2.49l0-.07a2.17,2.17,0,0,1,.51-.71,2.41,2.41,0,0,1,.79-.5,2.5,2.5,0,0,1,.94-.18,2.42,2.42,0,0,1,1.73.68,2.2,2.2,0,0,1,.52.71l0,.07a2.2,2.2,0,0,1,.17.86v3.23a2.14,2.14,0,0,1-.72,1.62,2.32,2.32,0,0,1-1.73.7,2.39,2.39,0,0,1-1.22-.32l-1.48,1.38a4.71,4.71,0,0,0,1.26.65,4.52,4.52,0,0,0,1.44.22,4.4,4.4,0,0,0,1.75-.34,4.71,4.71,0,0,0,1.43-.91,4.36,4.36,0,0,0,1-1.36,4,4,0,0,0,.35-1.64v-7.26h-2Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.91,346.43V347H84.54v-3.08h2.28v.54H85.15v.78h1.39v.53H85.15v.69Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.81,343.63v3.3H90.2v-.14a1.42,1.42,0,0,1-.69.18,1.23,1.23,0,0,1,0-2.46,1.45,1.45,0,0,1,.69.18v-1.06Zm-.61,2.59v-1a.9.9,0,0,0-.58-.2.68.68,0,0,0-.71.68.66.66,0,0,0,.71.68A.9.9,0,0,0,90.2,346.22Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.7,344.56v2.38h-.61v-.16a1.16,1.16,0,0,1-.65.19c-.69,0-1-.32-1-1.09v-1.32H93v1.32c0,.37.18.55.51.55a.81.81,0,0,0,.54-.19v-1.68Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.44,346.5a1.13,1.13,0,0,1-.91.47,1.23,1.23,0,1,1,0-2.45,1.12,1.12,0,0,1,.92.47l-.39.36a.66.66,0,0,0-.53-.28.68.68,0,1,0,0,1.36.65.65,0,0,0,.53-.3Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.34,344.56v2.38h-.61v-.18a1.22,1.22,0,0,1-.69.21,1.23,1.23,0,0,1,0-2.46,1.36,1.36,0,0,1,.69.2v-.15Zm-.61.71a.85.85,0,0,0-.58-.2.67.67,0,0,0-.71.67.69.69,0,0,0,.71.69.86.86,0,0,0,.58-.21Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104.73,345.07v.84c0,.42.07.54.37.54l.28,0v.46a1.84,1.84,0,0,1-.55.08.69.69,0,0,1-.72-.75v-1.15h-.33v-.51h.33v-.92h.62v.92h.66v.51Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.84,344a.35.35,0,0,1,.35-.35.36.36,0,0,1,0,.71A.36.36,0,0,1,106.84,344Zm0,.62h.61V347h-.61Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.64,345.75a1.3,1.3,0,1,1-1.3-1.23A1.26,1.26,0,0,1,111.64,345.75Zm-.6,0a.7.7,0,1,0-.7.68A.69.69,0,0,0,111,345.75Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.43,345.65V347h-.61v-1.32c0-.37-.18-.55-.52-.55a.75.75,0,0,0-.52.19V347h-.61V344.6h.61v.15a1,1,0,0,1,.63-.2C115.11,344.55,115.43,344.88,115.43,345.65Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.2,344.43v1.1h1.47v.54H120.2v.9h-.61v-3.08h2.33v.54Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.84,345.75a1.3,1.3,0,1,1-1.3-1.23A1.26,1.26,0,0,1,125.84,345.75Zm-.6,0a.7.7,0,0,0-1.4,0,.7.7,0,0,0,1.4,0Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.62,344.56v2.38H129v-.16a1.16,1.16,0,0,1-.65.19c-.69,0-1-.32-1-1.09v-1.32H128v1.32c0,.37.18.55.51.55a.81.81,0,0,0,.54-.19v-1.68Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.52,345.65V347h-.61v-1.32c0-.37-.18-.55-.51-.55a.78.78,0,0,0-.53.19V347h-.61V344.6h.61v.15a1.08,1.08,0,0,1,.64-.2C133.2,344.55,133.52,344.88,133.52,345.65Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.54,343.63v3.3h-.61v-.14a1.49,1.49,0,0,1-.7.18,1.23,1.23,0,0,1,0-2.46,1.45,1.45,0,0,1,.7.18v-1.06Zm-.61,2.59v-1a.93.93,0,0,0-.59-.2.67.67,0,0,0-.7.68.66.66,0,0,0,.7.68A1,1,0,0,0,136.93,346.22Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M141.56,344.56v2.38H141v-.18a1.22,1.22,0,0,1-.69.21,1.23,1.23,0,0,1,0-2.46,1.36,1.36,0,0,1,.69.2v-.15Zm-.61.71a.85.85,0,0,0-.58-.2.68.68,0,0,0-.71.67.69.69,0,0,0,.71.69.86.86,0,0,0,.58-.21Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144,345.07v.84c0,.42.07.54.37.54l.28,0v.46a1.84,1.84,0,0,1-.55.08.69.69,0,0,1-.72-.75v-1.15H143v-.51h.33v-.92H144v.92h.66v.51Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.07,344a.35.35,0,1,1,.69,0,.35.35,0,1,1-.69,0Zm0,.62h.61V347h-.61Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M150.86,345.75a1.3,1.3,0,1,1-1.3-1.23A1.26,1.26,0,0,1,150.86,345.75Zm-.6,0a.7.7,0,0,0-1.4,0,.7.7,0,0,0,1.4,0Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.65,345.65V347H154v-1.32c0-.37-.18-.55-.52-.55a.75.75,0,0,0-.52.19V347h-.61V344.6H153v.15a1,1,0,0,1,.63-.2C154.33,344.55,154.65,344.88,154.65,345.65Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.45,328l-1.1-1.46-.29.34V328h-.77V324.4h.77V326l1.29-1.61h1l-1.44,1.7L192.4,328Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.24,328v-.28a1.06,1.06,0,0,1-.83.34.87.87,0,0,1-.91-.87.84.84,0,0,1,.91-.85,1.09,1.09,0,0,1,.83.32v-.33c0-.27-.23-.44-.57-.44a1.12,1.12,0,0,0-.76.31l-.27-.48a1.69,1.69,0,0,1,1.15-.42c.6,0,1.15.24,1.15,1V328Zm0-.63v-.33a.69.69,0,0,0-.55-.23c-.28,0-.5.14-.5.39s.22.4.5.4A.69.69,0,0,0,194.24,327.4Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.4,328v-1.59c0-.37-.19-.49-.49-.49a.74.74,0,0,0-.59.3V328h-.7V325.4h.7v.34a1.19,1.19,0,0,1,.92-.41.77.77,0,0,1,.86.84V328Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M198.72,328.7l.32-.49a1,1,0,0,0,.82.32.65.65,0,0,0,.73-.68v-.25a1,1,0,0,1-.82.41c-.65,0-1.16-.46-1.16-1.34a1.18,1.18,0,0,1,1.16-1.34,1,1,0,0,1,.82.41v-.34h.69v2.45c0,1-.77,1.25-1.42,1.25A1.63,1.63,0,0,1,198.72,328.7Zm1.87-1.6v-.86a.77.77,0,0,0-.6-.29.65.65,0,0,0-.67.72.66.66,0,0,0,.67.73A.78.78,0,0,0,200.59,327.1Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M203.55,328v-.28a1.07,1.07,0,0,1-.84.34.87.87,0,0,1-.9-.87.83.83,0,0,1,.9-.85,1.11,1.11,0,0,1,.84.32v-.33c0-.27-.23-.44-.58-.44a1.12,1.12,0,0,0-.76.31l-.27-.48a1.7,1.7,0,0,1,1.15-.42c.61,0,1.16.24,1.16,1V328Zm0-.63v-.33a.71.71,0,0,0-.56-.23c-.27,0-.49.14-.49.39s.22.4.49.4A.71.71,0,0,0,203.55,327.4Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M204.93,328V325.4h.69v.35a1.15,1.15,0,0,1,.84-.42V326l-.19,0a.87.87,0,0,0-.65.3V328Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M206.72,326.71a1.4,1.4,0,1,1,1.39,1.38A1.33,1.33,0,0,1,206.72,326.71Zm2.07,0a.68.68,0,1,0-1.35,0,.68.68,0,1,0,1.35,0Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M209.86,326.71a1.39,1.39,0,1,1,1.39,1.38A1.33,1.33,0,0,1,209.86,326.71Zm2.06,0a.68.68,0,1,0-1.34,0,.68.68,0,1,0,1.34,0Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.58,328V324.4h2.57v.68h-1.8v.76h1.76v.68h-1.76v.83h1.8V328Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M219.55,328v-.34a1,1,0,0,1-.81.4c-.66,0-1.17-.5-1.17-1.38a1.22,1.22,0,0,1,1.17-1.38,1,1,0,0,1,.81.41V324.4h.69V328Zm0-.85v-.93a.75.75,0,0,0-.6-.3.77.77,0,0,0,0,1.53A.78.78,0,0,0,219.55,327.18Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.71,328v-.33a1.28,1.28,0,0,1-.93.39.75.75,0,0,1-.85-.82V325.4h.69V327a.43.43,0,0,0,.49.49.78.78,0,0,0,.6-.3V325.4h.69V328Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M223.92,326.71a1.34,1.34,0,0,1,1.39-1.38,1.25,1.25,0,0,1,1.05.48l-.46.42a.63.63,0,0,0-.55-.28.7.7,0,0,0-.72.76.71.71,0,0,0,.72.77.64.64,0,0,0,.55-.29l.46.42a1.25,1.25,0,0,1-1.05.48A1.34,1.34,0,0,1,223.92,326.71Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M228.39,328v-.28a1.06,1.06,0,0,1-.83.34.87.87,0,0,1-.91-.87.84.84,0,0,1,.91-.85,1.11,1.11,0,0,1,.83.32v-.33c0-.27-.23-.44-.58-.44a1.12,1.12,0,0,0-.76.31l-.27-.48a1.7,1.7,0,0,1,1.15-.42c.61,0,1.16.24,1.16,1V328Zm0-.63v-.33a.71.71,0,0,0-.56-.23c-.27,0-.49.14-.49.39s.22.4.49.4A.71.71,0,0,0,228.39,327.4Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M229.91,327.37V326h-.44v-.6h.44v-.72h.69v.72h.54v.6h-.54v1.18c0,.17.09.3.24.3a.36.36,0,0,0,.24-.08l.15.53a.87.87,0,0,1-.58.16A.65.65,0,0,1,229.91,327.37Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M231.55,324.7a.4.4,0,0,1,.4-.41.41.41,0,1,1,0,.82A.4.4,0,0,1,231.55,324.7Zm.06,3.33V325.4h.69V328Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M232.82,326.71a1.4,1.4,0,1,1,1.39,1.38A1.33,1.33,0,0,1,232.82,326.71Zm2.07,0a.68.68,0,1,0-1.35,0,.68.68,0,1,0,1.35,0Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M237.9,328v-1.59c0-.37-.19-.49-.48-.49a.76.76,0,0,0-.6.3V328h-.7V325.4h.7v.34a1.21,1.21,0,0,1,.92-.41.77.77,0,0,1,.86.84V328Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M240.7,328V324.4h2.57v.68h-1.8v.76h1.76v.68h-1.76V328Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M243.63,326.71a1.39,1.39,0,1,1,1.38,1.38A1.33,1.33,0,0,1,243.63,326.71Zm2.06,0A.69.69,0,0,0,245,326a.68.68,0,0,0-.66.76.69.69,0,0,0,.66.77A.7.7,0,0,0,245.69,326.71Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M248.7,328v-.33a1.24,1.24,0,0,1-.92.39.75.75,0,0,1-.85-.82V325.4h.69V327c0,.37.19.49.49.49a.77.77,0,0,0,.59-.3V325.4h.7V328Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M251.86,328v-1.59c0-.37-.19-.49-.48-.49a.76.76,0,0,0-.6.3V328h-.69V325.4h.69v.34a1.21,1.21,0,0,1,.92-.41.77.77,0,0,1,.86.84V328Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M255.05,328v-.34a1,1,0,0,1-.81.4c-.66,0-1.17-.5-1.17-1.38a1.22,1.22,0,0,1,1.17-1.38,1,1,0,0,1,.81.41V324.4h.7V328Zm0-.85v-.93a.73.73,0,0,0-.59-.3.77.77,0,0,0,0,1.53A.76.76,0,0,0,255.05,327.18Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M258,328v-.28a1.07,1.07,0,0,1-.84.34.87.87,0,0,1-.91-.87.84.84,0,0,1,.91-.85,1.11,1.11,0,0,1,.84.32v-.33c0-.27-.23-.44-.58-.44a1.12,1.12,0,0,0-.76.31l-.27-.48a1.69,1.69,0,0,1,1.15-.42c.6,0,1.15.24,1.15,1V328Zm0-.63v-.33a.72.72,0,0,0-.56-.23c-.27,0-.5.14-.5.39s.23.4.5.4A.72.72,0,0,0,258,327.4Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M259.54,327.37V326h-.44v-.6h.44v-.72h.69v.72h.53v.6h-.53v1.18c0,.17.09.3.24.3a.38.38,0,0,0,.24-.08l.15.53a.89.89,0,0,1-.58.16A.65.65,0,0,1,259.54,327.37Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M261.17,324.7a.42.42,0,1,1,.41.41A.41.41,0,0,1,261.17,324.7Zm.07,3.33V325.4h.69V328Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M262.45,326.71a1.39,1.39,0,1,1,1.39,1.38A1.33,1.33,0,0,1,262.45,326.71Zm2.06,0a.68.68,0,1,0-1.34,0,.68.68,0,1,0,1.34,0Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M267.53,328v-1.59c0-.37-.19-.49-.49-.49a.78.78,0,0,0-.6.3V328h-.69V325.4h.69v.34a1.23,1.23,0,0,1,.92-.41.76.76,0,0,1,.86.84V328Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M270.32,328V324.4H272a1.17,1.17,0,1,1,0,2.33h-.92V328Zm2.13-2.46a.48.48,0,0,0-.53-.49h-.82v1h.82A.48.48,0,0,0,272.45,325.57Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M273.15,327.65a.45.45,0,0,1,.45-.44.44.44,0,0,1,0,.88A.45.45,0,0,1,273.15,327.65Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M276,328V324.4h.78v3h1.53V328Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M278.79,327.37V326h-.44v-.6h.44v-.72h.69v.72H280v.6h-.54v1.18c0,.17.09.3.24.3a.36.36,0,0,0,.24-.08l.15.53a.87.87,0,0,1-.58.16A.65.65,0,0,1,278.79,327.37Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M282.3,328v-.34a1,1,0,0,1-.81.4c-.66,0-1.17-.5-1.17-1.38a1.22,1.22,0,0,1,1.17-1.38,1,1,0,0,1,.81.41V324.4h.7V328Zm0-.85v-.93a.75.75,0,0,0-.59-.3.77.77,0,0,0,0,1.53A.78.78,0,0,0,282.3,327.18Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M283.6,327.65a.44.44,0,1,1,.44.44A.44.44,0,0,1,283.6,327.65Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M189.35,335.3v-3.64h1.46a1.1,1.1,0,1,1,0,2.19h-1v1.45Zm2.13-2.54a.67.67,0,0,0-.72-.69h-.95v1.38h.95A.67.67,0,0,0,191.48,332.76Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.07,335.3V335a1.11,1.11,0,0,1-.87.36.87.87,0,0,1-.91-.87.86.86,0,0,1,.91-.87,1.11,1.11,0,0,1,.87.36v-.47c0-.35-.28-.56-.66-.56a1,1,0,0,0-.81.37l-.19-.28a1.37,1.37,0,0,1,1.05-.44c.57,0,1,.25,1,.89v1.81Zm0-.56v-.5a.88.88,0,0,0-.72-.32.58.58,0,1,0,0,1.15A.86.86,0,0,0,194.07,334.74Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.21,335.3v-.39a1.1,1.1,0,0,1-.88.45c-.69,0-1.18-.52-1.18-1.38a1.22,1.22,0,0,1,1.18-1.38,1.11,1.11,0,0,1,.88.46v-1.4h.41v3.64Zm0-.72v-1.19a1,1,0,0,0-.78-.42c-.53,0-.85.43-.85,1s.32,1,.85,1A1,1,0,0,0,197.21,334.58Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M201.62,335.3v-1.79c0-.33-.14-.54-.49-.54a.89.89,0,0,0-.69.4v1.93H200v-1.79c0-.33-.14-.54-.49-.54a.92.92,0,0,0-.69.4v1.93h-.41v-2.63h.41v.38a1.14,1.14,0,0,1,.86-.45.68.68,0,0,1,.7.49,1.11,1.11,0,0,1,.88-.49c.48,0,.74.27.74.8v1.9Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.69,334a1.31,1.31,0,1,1,1.31,1.38A1.3,1.3,0,0,1,202.69,334Zm2.18,0a.89.89,0,1,0-.87,1A.91.91,0,0,0,204.87,334Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M207.87,335.3v-.39a1.12,1.12,0,0,1-.89.45c-.68,0-1.17-.52-1.17-1.38A1.22,1.22,0,0,1,207,332.6a1.11,1.11,0,0,1,.89.46v-1.4h.41v3.64Zm0-.72v-1.19a1,1,0,0,0-.78-.42c-.54,0-.85.43-.85,1s.31,1,.85,1A1,1,0,0,0,207.87,334.58Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M210.74,335.3V335a1.11,1.11,0,0,1-.87.36.87.87,0,0,1-.91-.87.86.86,0,0,1,.91-.87,1.11,1.11,0,0,1,.87.36v-.47c0-.35-.28-.56-.66-.56a1,1,0,0,0-.81.37l-.19-.28a1.37,1.37,0,0,1,1-.44c.57,0,1,.25,1,.89v1.81Zm0-.56v-.5a.88.88,0,0,0-.72-.32.58.58,0,1,0,0,1.15A.86.86,0,0,0,210.74,334.74Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M211.9,336a.78.78,0,0,0,.22,0,.37.37,0,0,0,.39-.28l.18-.4-1.11-2.65H212l.87,2.15.88-2.15h.44l-1.32,3.16a.78.78,0,0,1-.77.54,1.27,1.27,0,0,1-.29,0Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M216.29,335.3V335a1.11,1.11,0,0,1-.87.36.87.87,0,0,1-.91-.87.85.85,0,0,1,.91-.87,1.11,1.11,0,0,1,.87.36v-.47c0-.35-.28-.56-.66-.56a1,1,0,0,0-.81.37l-.19-.28a1.35,1.35,0,0,1,1.05-.44c.56,0,1,.25,1,.89v1.81Zm0-.56v-.5a.88.88,0,0,0-.72-.32.58.58,0,1,0,0,1.15A.86.86,0,0,0,216.29,334.74Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.06,335.3v-3.06l-1.23,3.06h-.19l-1.23-3.06v3.06H219v-3.64h.65l1.14,2.8,1.12-2.8h.65v3.64Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M223.2,334a1.3,1.3,0,1,1,1.3,1.38A1.29,1.29,0,0,1,223.2,334Zm2.17,0a.88.88,0,1,0-.87,1A.91.91,0,0,0,225.37,334Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M228.37,335.3v-.39a1.1,1.1,0,0,1-.88.45c-.69,0-1.18-.52-1.18-1.38a1.22,1.22,0,0,1,1.18-1.38,1.11,1.11,0,0,1,.88.46v-1.4h.41v3.64Zm0-.72v-1.19a1,1,0,0,0-.78-.42c-.53,0-.85.43-.85,1s.32,1,.85,1A1,1,0,0,0,228.37,334.58Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M229.45,334a1.31,1.31,0,0,1,1.29-1.38A1.28,1.28,0,0,1,232,334v.11h-2.13a.93.93,0,0,0,1,.9,1.12,1.12,0,0,0,.81-.33l.2.26a1.42,1.42,0,0,1-1.05.41A1.3,1.3,0,0,1,229.45,334Zm1.29-1a.87.87,0,0,0-.86.87h1.73A.85.85,0,0,0,230.74,332.94Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M232.74,336l-.21-.17a.79.79,0,0,0,.36-.51h-.08a.26.26,0,0,1-.26-.27.3.3,0,0,1,.29-.3.37.37,0,0,1,.34.42A1,1,0,0,1,232.74,336Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M235.31,335.3v-3.64h1.46a1.1,1.1,0,1,1,0,2.19h-1v1.45Zm2.13-2.54a.67.67,0,0,0-.72-.69h-.95v1.38h.95A.67.67,0,0,0,237.44,332.76Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M240.27,335.3v-.37a1.26,1.26,0,0,1-.93.43.74.74,0,0,1-.84-.84v-1.85h.41v1.73c0,.46.23.6.59.6a1,1,0,0,0,.77-.4v-1.93h.41v2.63Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M241.58,334.75V333h-.43v-.36h.43V332H242v.72h.53V333H242v1.63c0,.2.08.34.26.34a.36.36,0,0,0,.27-.12l.13.31a.69.69,0,0,1-.49.17A.54.54,0,0,1,241.58,334.75Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M244.75,335.3V335a1.12,1.12,0,0,1-.87.36.87.87,0,0,1-.92-.87.86.86,0,0,1,.92-.87,1.11,1.11,0,0,1,.87.36v-.47c0-.35-.29-.56-.67-.56a1,1,0,0,0-.8.37l-.19-.28a1.35,1.35,0,0,1,1-.44c.56,0,1,.25,1,.89v1.81Zm0-.56v-.5a.9.9,0,0,0-.72-.32.58.58,0,1,0,0,1.15A.88.88,0,0,0,244.75,334.74Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M246,335.3v-3.64h.41v3.64Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M247.14,332a.28.28,0,1,1,.55,0,.28.28,0,0,1-.55,0Zm.07,3.28v-2.63h.41v2.63Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M248.21,335l.21-.3a1.14,1.14,0,0,0,.86.38c.41,0,.63-.19.63-.45,0-.64-1.63-.25-1.63-1.22,0-.42.35-.76,1-.76a1.32,1.32,0,0,1,1,.38l-.19.29a1,1,0,0,0-.78-.34c-.36,0-.59.18-.59.42,0,.57,1.63.19,1.63,1.22,0,.44-.35.79-1,.79A1.41,1.41,0,0,1,248.21,335Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M252.61,335.3V335a1.11,1.11,0,0,1-.87.36.87.87,0,0,1-.91-.87.86.86,0,0,1,.91-.87,1.11,1.11,0,0,1,.87.36v-.47c0-.35-.28-.56-.66-.56a1,1,0,0,0-.81.37L251,333a1.37,1.37,0,0,1,1.05-.44c.57,0,1,.25,1,.89v1.81Zm0-.56v-.5a.88.88,0,0,0-.72-.32.58.58,0,1,0,0,1.15A.86.86,0,0,0,252.61,334.74Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M255.75,335.3v-.39a1.1,1.1,0,0,1-.88.45c-.69,0-1.18-.52-1.18-1.38a1.22,1.22,0,0,1,1.18-1.38,1.11,1.11,0,0,1,.88.46v-1.4h.41v3.64Zm0-.72v-1.19A1,1,0,0,0,255,333c-.53,0-.85.43-.85,1s.32,1,.85,1A1,1,0,0,0,255.75,334.58Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M258.63,335.3V335a1.14,1.14,0,0,1-.87.36.87.87,0,0,1-.92-.87.86.86,0,0,1,.92-.87,1.14,1.14,0,0,1,.87.36v-.47c0-.35-.29-.56-.67-.56a1,1,0,0,0-.8.37L257,333a1.35,1.35,0,0,1,1-.44c.56,0,1,.25,1,.89v1.81Zm0-.56v-.5a.9.9,0,0,0-.72-.32.58.58,0,1,0,0,1.15A.88.88,0,0,0,258.63,334.74Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M261.65,335.3l-.94-1.18-.44.43v.75h-.41v-3.64h.41v2.41l1.38-1.4h.52L261,333.86l1.18,1.44Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M262.77,336l-.21-.17a.79.79,0,0,0,.36-.51h-.08a.26.26,0,0,1-.26-.27.3.3,0,0,1,.29-.3.37.37,0,0,1,.34.42A1,1,0,0,1,262.77,336Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M267.54,335.3l-1.38-1.64-.36.42v1.22h-.46v-3.64h.46v1.88l1.6-1.88H268l-1.52,1.73,1.66,1.91Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M270.16,335.3V335a1.15,1.15,0,0,1-.88.36.87.87,0,0,1-.91-.87.86.86,0,0,1,.91-.87,1.15,1.15,0,0,1,.88.36v-.47c0-.35-.29-.56-.67-.56a1,1,0,0,0-.8.37l-.2-.28a1.39,1.39,0,0,1,1.06-.44c.56,0,1,.25,1,.89v1.81Zm0-.56v-.5a.9.9,0,0,0-.72-.32.58.58,0,1,0,0,1.15A.88.88,0,0,0,270.16,334.74Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M271.47,334.75V333H271v-.36h.43V332h.42v.72h.53V333h-.53v1.63c0,.2.08.34.26.34a.36.36,0,0,0,.27-.12l.12.31a.64.64,0,0,1-.48.17A.54.54,0,0,1,271.47,334.75Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M274.77,335.3v-1.74c0-.46-.23-.59-.59-.59a1,1,0,0,0-.77.4v1.93H273v-3.64h.41v1.39a1.24,1.24,0,0,1,.93-.45.74.74,0,0,1,.84.84v1.86Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M279.18,335.3v-1.79c0-.33-.15-.54-.49-.54a.92.92,0,0,0-.7.4v1.93h-.4v-1.79c0-.33-.14-.54-.49-.54a.91.91,0,0,0-.69.4v1.93H276v-2.63h.41v.38a1.13,1.13,0,0,1,.85-.45.69.69,0,0,1,.71.49,1.09,1.09,0,0,1,.88-.49c.48,0,.74.27.74.8v1.9Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M282.05,335.3V335a1.12,1.12,0,0,1-.87.36.88.88,0,0,1-.92-.87.86.86,0,0,1,.92-.87,1.11,1.11,0,0,1,.87.36v-.47c0-.35-.28-.56-.66-.56a1,1,0,0,0-.81.37l-.19-.28a1.35,1.35,0,0,1,1.05-.44c.56,0,1,.25,1,.89v1.81Zm0-.56v-.5a.9.9,0,0,0-.72-.32.58.58,0,1,0,0,1.15A.88.88,0,0,0,282.05,334.74Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M285.07,335.3v-1.72c0-.47-.24-.61-.6-.61a1,1,0,0,0-.78.4v1.93h-.41v-2.63h.41v.38a1.28,1.28,0,0,1,.94-.45.75.75,0,0,1,.84.85v1.85Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M288.2,335.3v-.39a1.13,1.13,0,0,1-.89.45c-.69,0-1.17-.52-1.17-1.38s.48-1.38,1.17-1.38a1.11,1.11,0,0,1,.89.46v-1.4h.41v3.64Zm0-.72v-1.19a1,1,0,0,0-.79-.42c-.53,0-.84.43-.84,1s.31,1,.84,1A1,1,0,0,0,288.2,334.58Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M291.2,335.3v-.37a1.26,1.26,0,0,1-.93.43.74.74,0,0,1-.84-.84v-1.85h.41v1.73c0,.46.23.6.59.6a1,1,0,0,0,.77-.4v-1.93h.41v2.63Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M292.54,336l-.21-.17a.83.83,0,0,0,.36-.51h-.08a.26.26,0,0,1-.26-.27.29.29,0,0,1,.29-.3.37.37,0,0,1,.34.42A1,1,0,0,1,292.54,336Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M297.68,335.3l-2.12-2.9v2.9h-.45v-3.64h.47l2.09,2.84v-2.84h.45v3.64Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M298.8,334a1.32,1.32,0,0,1,1.3-1.38,1.28,1.28,0,0,1,1.26,1.41v.11h-2.12a.91.91,0,0,0,.94.9,1.12,1.12,0,0,0,.82-.33l.19.26a1.4,1.4,0,0,1-1,.41A1.3,1.3,0,0,1,298.8,334Zm1.29-1a.87.87,0,0,0-.86.87H301A.85.85,0,0,0,300.09,332.94Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M302.43,334.9v1.4H302v-3.63h.41v.39a1.1,1.1,0,0,1,.89-.46c.69,0,1.17.52,1.17,1.38s-.48,1.38-1.17,1.38A1.1,1.1,0,0,1,302.43,334.9Zm1.63-.92c0-.58-.31-1-.84-1a1,1,0,0,0-.79.42v1.18a1,1,0,0,0,.79.43C303.75,335,304.06,334.56,304.06,334Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M306.79,335.3V335a1.12,1.12,0,0,1-.87.36.87.87,0,0,1-.92-.87.86.86,0,0,1,.92-.87,1.11,1.11,0,0,1,.87.36v-.47c0-.35-.29-.56-.67-.56a1,1,0,0,0-.8.37l-.19-.28a1.35,1.35,0,0,1,1.05-.44c.56,0,1,.25,1,.89v1.81Zm0-.56v-.5a.9.9,0,0,0-.72-.32.58.58,0,1,0,0,1.15A.88.88,0,0,0,306.79,334.74Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M308,335.3v-3.64h.41v3.64Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M190.25,342.57v-3.24H189.1v-.4h2.76v.4h-1.15v3.24Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M192.09,340.2a.3.3,0,0,1,.6,0,.3.3,0,1,1-.6,0Zm0,2.12a.3.3,0,1,1,.3.3A.31.31,0,0,1,192.09,342.32Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.92,340.87V342h-.31v-1.16h-1.05v-.28h1.05v-1.13h.31v1.13h1v.28Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.58,342.19l.23-.34a.92.92,0,0,0,.78.37c.73,0,1-.73,1-1.43v-.14a1.31,1.31,0,0,1-1,.57,1.1,1.1,0,0,1-1.19-1.16,1.19,1.19,0,0,1,1.27-1.19c1,0,1.41.89,1.41,1.88s-.46,1.88-1.48,1.88A1.27,1.27,0,0,1,197.58,342.19Zm2-1.91c0-.44-.29-1-.92-1a.78.78,0,0,0-.83.76.75.75,0,0,0,.84.79A1.12,1.12,0,0,0,199.6,340.28Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M201,342.57l1.47-3.24h-2v-.4H203v.31l-1.49,3.33Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M203.81,342.57l1.47-3.24h-2v-.4h2.48v.31l-1.49,3.33Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M206.12,341.43v-.36h1.31v.36Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M208.56,342.57v-3l-.58.62-.27-.28.91-.94h.4v3.64Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M209.61,341.43v-.36h1.3v.36Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M211.44,342.05l.27-.31a1.21,1.21,0,0,0,1,.49.79.79,0,0,0,.84-.78.78.78,0,0,0-.84-.79,1.2,1.2,0,0,0-.84.34l-.33-.11v-2h2.22v.4H212v1.27a1.23,1.23,0,0,1,.85-.33,1.11,1.11,0,0,1,1.16,1.16,1.19,1.19,0,0,1-1.29,1.2A1.48,1.48,0,0,1,211.44,342.05Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.45,342l.27-.28a1.26,1.26,0,0,0,1,.48c.53,0,.85-.27.85-.68s-.37-.65-.9-.65h-.38v-.41h.38c.46,0,.84-.18.84-.6s-.37-.62-.81-.62a1.23,1.23,0,0,0-1,.44l-.25-.28a1.56,1.56,0,0,1,1.25-.56c.7,0,1.22.35,1.22,1a.88.88,0,0,1-.77.85.92.92,0,0,1,.83.89c0,.61-.49,1.05-1.29,1.05A1.54,1.54,0,0,1,214.45,342Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M217.49,342l.26-.28a1.3,1.3,0,0,0,1,.48c.53,0,.85-.27.85-.68s-.37-.65-.91-.65h-.37v-.41h.37c.46,0,.85-.18.85-.6s-.37-.62-.81-.62a1.21,1.21,0,0,0-1,.44l-.25-.28a1.56,1.56,0,0,1,1.24-.56c.7,0,1.23.35,1.23,1a.88.88,0,0,1-.78.85.92.92,0,0,1,.84.89c0,.61-.49,1.05-1.29,1.05A1.51,1.51,0,0,1,217.49,342Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.52,342l.27-.28a1.26,1.26,0,0,0,1,.48c.53,0,.85-.27.85-.68s-.37-.65-.9-.65h-.38v-.41h.38c.46,0,.84-.18.84-.6s-.37-.62-.81-.62a1.23,1.23,0,0,0-1,.44l-.25-.28a1.56,1.56,0,0,1,1.25-.56c.7,0,1.23.35,1.23,1a.89.89,0,0,1-.78.85.93.93,0,0,1,.84.89c0,.61-.49,1.05-1.29,1.05A1.55,1.55,0,0,1,220.52,342Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M223.68,340.75c0-.89.39-1.87,1.39-1.87s1.39,1,1.39,1.87-.4,1.88-1.39,1.88S223.68,341.63,223.68,340.75Zm2.31,0c0-.72-.23-1.47-.92-1.47s-.93.75-.93,1.47.24,1.48.93,1.48S226,341.48,226,340.75Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M227,341.64a1.09,1.09,0,0,1,.87-.95,1,1,0,0,1-.81-.87c0-.65.64-.94,1.24-.94s1.25.29,1.25.94a1,1,0,0,1-.81.87,1.09,1.09,0,0,1,.87.95c0,.62-.59,1-1.31,1S227,342.27,227,341.64Zm2.15,0c0-.48-.62-.68-.85-.71s-.84.23-.84.71.39.63.84.63S229.17,342,229.17,341.6Zm-.06-1.72c0-.38-.35-.6-.79-.6s-.78.22-.78.6.57.59.78.63S229.11,340.32,229.11,339.88Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M230.19,341.64a1.09,1.09,0,0,1,.87-.95,1,1,0,0,1-.81-.87c0-.65.64-.94,1.25-.94s1.24.29,1.24.94a1,1,0,0,1-.81.87,1.09,1.09,0,0,1,.87.95c0,.62-.59,1-1.3,1S230.19,342.27,230.19,341.64Zm2.15,0c0-.48-.62-.68-.84-.71s-.85.23-.85.71.39.63.85.63S232.34,342,232.34,341.6Zm-.05-1.72c0-.38-.36-.6-.79-.6s-.79.22-.79.6.57.59.79.63S232.29,340.32,232.29,339.88Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M233.08,342.67l1.29-3.85h.33l-1.3,3.85Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M235.67,342.57v-3l-.59.62-.27-.28.91-.94h.4v3.64Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.82,340.75c0-.89.39-1.87,1.39-1.87s1.39,1,1.39,1.87-.4,1.88-1.39,1.88S236.82,341.63,236.82,340.75Zm2.32,0c0-.72-.24-1.47-.93-1.47s-.93.75-.93,1.47.24,1.48.93,1.48S239.14,341.48,239.14,340.75Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M240.54,342.57l1.46-3.24h-1.95v-.4h2.48v.31L241,342.57Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M189.35,349.83V346.2h2.38v.4h-1.92v1.17h1.89v.41h-1.89v1.25h1.92v.4Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M192.36,347.46a.3.3,0,0,1,.3-.3.3.3,0,0,1,0,.6A.3.3,0,0,1,192.36,347.46Zm0,2.13a.3.3,0,0,1,.3-.3.3.3,0,0,1,0,.6A.3.3,0,0,1,192.36,349.59Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195,346.55a.28.28,0,0,1,.55,0,.28.28,0,1,1-.55,0Zm.07,3.28V347.2h.41v2.63Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M198.09,349.83v-1.72c0-.47-.24-.61-.6-.61a1,1,0,0,0-.78.41v1.92h-.41V347.2h.41v.38a1.32,1.32,0,0,1,.95-.44.75.75,0,0,1,.83.85v1.84Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M199.43,349.83v-2.27H199v-.36h.44V347a.75.75,0,0,1,.76-.85.79.79,0,0,1,.56.2l-.17.26a.46.46,0,0,0-.32-.13c-.28,0-.42.18-.42.52v.2h.53v.36h-.53v2.27Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200.71,348.52a1.3,1.3,0,1,1,1.3,1.38A1.29,1.29,0,0,1,200.71,348.52Zm2.17,0a.88.88,0,1,0-.87,1A.92.92,0,0,0,202.88,348.52Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M203.76,348.5a2.2,2.2,0,0,1,2.16-2.14,1.67,1.67,0,0,1,1.72,1.73c0,.84-.48,1.28-.94,1.28a.47.47,0,0,1-.5-.44v0a1.1,1.1,0,0,1-.86.48.82.82,0,0,1-.84-.89,1.37,1.37,0,0,1,1.28-1.36.73.73,0,0,1,.7.42l.07-.34h.37l-.31,1.48s0,.08,0,.11a.26.26,0,0,0,.26.29c.21,0,.59-.24.59-1a1.48,1.48,0,0,0-1.54-1.55,2,2,0,0,0-2,1.95,1.52,1.52,0,0,0,1.56,1.55,1.8,1.8,0,0,0,1-.31l.1.14a2.09,2.09,0,0,1-1.13.35A1.69,1.69,0,0,1,203.76,348.5Zm2.5.08.15-.76a.58.58,0,0,0-.56-.4,1,1,0,0,0-1,1,.55.55,0,0,0,.56.61A1.06,1.06,0,0,0,206.26,348.58Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M210,349.83l-.94-1.18-.44.43v.75h-.41V346.2h.41v2.4l1.38-1.4h.52l-1.17,1.2,1.17,1.43Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M212.69,349.83v-.3a1.12,1.12,0,0,1-.87.37.87.87,0,0,1-.91-.87.85.85,0,0,1,.91-.87,1.11,1.11,0,0,1,.87.36V348c0-.35-.28-.55-.66-.55a1,1,0,0,0-.81.37l-.19-.29a1.4,1.4,0,0,1,1.05-.43c.57,0,1,.25,1,.89v1.8Zm0-.55v-.5a.84.84,0,0,0-.71-.32.58.58,0,1,0,0,1.14A.84.84,0,0,0,212.69,349.28Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.71,349.83v-1.72c0-.47-.24-.61-.59-.61a1,1,0,0,0-.78.41v1.92h-.41V347.2h.41v.38a1.28,1.28,0,0,1,.94-.44.75.75,0,0,1,.83.85v1.84Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M216.93,350.5l.21-.29a1,1,0,0,0,.85.35.75.75,0,0,0,.85-.76v-.4a1.11,1.11,0,0,1-.88.47,1.38,1.38,0,0,1,0-2.73,1.08,1.08,0,0,1,.88.46v-.4h.41v2.6c0,.83-.61,1.1-1.26,1.1A1.35,1.35,0,0,1,216.93,350.5Zm1.91-1.42v-1.16a1,1,0,0,0-.78-.42c-.53,0-.85.42-.85,1s.32,1,.85,1A1,1,0,0,0,218.84,349.08Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M221.72,349.83v-.3a1.15,1.15,0,0,1-.88.37.87.87,0,0,1-.91-.87.85.85,0,0,1,.91-.87,1.15,1.15,0,0,1,.88.36V348c0-.35-.29-.55-.67-.55a1,1,0,0,0-.8.37l-.2-.29a1.42,1.42,0,0,1,1.06-.43c.56,0,1,.25,1,.89v1.8Zm0-.55v-.5a.88.88,0,0,0-.72-.32.58.58,0,1,0,0,1.14A.88.88,0,0,0,221.72,349.28Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M223,349.83V347.2h.41v.42a1.14,1.14,0,0,1,.88-.48v.42h-.16a1,1,0,0,0-.72.42v1.86Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M224.6,348.52a1.3,1.3,0,1,1,1.3,1.38A1.29,1.29,0,0,1,224.6,348.52Zm2.17,0a.88.88,0,1,0-.87,1A.92.92,0,0,0,226.77,348.52Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M227.71,348.52A1.31,1.31,0,1,1,229,349.9,1.3,1.3,0,0,1,227.71,348.52Zm2.18,0a.88.88,0,1,0-.87,1A.92.92,0,0,0,229.89,348.52Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M230.83,348.52a1.32,1.32,0,0,1,1.3-1.38,1.28,1.28,0,0,1,1.26,1.41v.1h-2.12a.91.91,0,0,0,.94.91,1.15,1.15,0,0,0,.82-.34l.19.27a1.44,1.44,0,0,1-1,.41A1.3,1.3,0,0,1,230.83,348.52Zm1.29-1a.88.88,0,0,0-.86.88H233A.86.86,0,0,0,232.12,347.47Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236,349.83v-.39a1.11,1.11,0,0,1-.89.46c-.68,0-1.17-.52-1.17-1.38a1.22,1.22,0,0,1,1.17-1.38,1.09,1.09,0,0,1,.89.46v-1.4h.41v3.63Zm0-.72v-1.18a1,1,0,0,0-.78-.43c-.54,0-.85.44-.85,1s.31,1,.85,1A1,1,0,0,0,236,349.11Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M239,349.83v-.37a1.27,1.27,0,0,1-.93.44.74.74,0,0,1-.84-.84V347.2h.41v1.73c0,.47.23.6.59.6a1,1,0,0,0,.77-.39V347.2h.41v2.63Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M240.11,349.59a.3.3,0,1,1,.3.3A.31.31,0,0,1,240.11,349.59Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M241.26,348.52a1.3,1.3,0,0,1,1.31-1.38,1.13,1.13,0,0,1,1,.45l-.28.25a.76.76,0,0,0-.67-.34,1,1,0,0,0,0,2,.76.76,0,0,0,.67-.34l.28.25a1.14,1.14,0,0,1-1,.46A1.31,1.31,0,0,1,241.26,348.52Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M244,348.52a1.31,1.31,0,1,1,1.31,1.38A1.29,1.29,0,0,1,244,348.52Zm2.18,0a.88.88,0,1,0-.87,1A.92.92,0,0,0,246.14,348.52Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M250.41,349.83v-1.78c0-.34-.14-.55-.48-.55a.88.88,0,0,0-.7.41v1.92h-.41v-1.78c0-.34-.14-.55-.49-.55a.93.93,0,0,0-.69.41v1.92h-.41V347.2h.41v.38a1.2,1.2,0,0,1,.86-.44.67.67,0,0,1,.7.49,1.11,1.11,0,0,1,.88-.49c.48,0,.74.26.74.79v1.9Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.62,357.1l-.69-2.11-.69,2.11h-.41l-.84-2.63h.43l.64,2.1.69-2.1h.36l.68,2.1.65-2.1h.43L192,357.1Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.62,357.1l-.69-2.11-.69,2.11h-.41l-.83-2.63h.42l.64,2.1.7-2.1h.35l.69,2.1.64-2.1h.43L196,357.1Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M199.62,357.1l-.69-2.11-.69,2.11h-.4l-.84-2.63h.42l.64,2.1.7-2.1h.35l.69,2.1.64-2.1h.43L200,357.1Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M201,356.86a.3.3,0,0,1,.6,0,.3.3,0,1,1-.6,0Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M204.15,357.1l-.94-1.18-.44.43v.75h-.41v-3.63h.41v2.4l1.38-1.4h.52l-1.17,1.19,1.18,1.44Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M206.81,357.1v-.3a1.13,1.13,0,0,1-.87.37.87.87,0,0,1-.92-.87.86.86,0,0,1,.92-.87,1.1,1.1,0,0,1,.87.35v-.47c0-.35-.29-.55-.67-.55a1,1,0,0,0-.8.36l-.19-.28a1.38,1.38,0,0,1,1-.43c.56,0,1,.25,1,.88v1.81Zm0-.55v-.5a.88.88,0,0,0-.72-.33.58.58,0,1,0,0,1.15A.9.9,0,0,0,206.81,356.55Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M209.82,357.1v-1.72c0-.47-.24-.61-.59-.61a1,1,0,0,0-.78.41v1.92H208v-2.63h.41v.38a1.28,1.28,0,0,1,.94-.44.74.74,0,0,1,.83.85v1.84Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M211,357.77l.21-.29a1,1,0,0,0,.86.35.75.75,0,0,0,.85-.77v-.39a1.14,1.14,0,0,1-.89.46c-.69,0-1.17-.51-1.17-1.36a1.2,1.2,0,0,1,1.17-1.36,1.11,1.11,0,0,1,.89.46v-.4h.4v2.59c0,.84-.61,1.11-1.25,1.11A1.36,1.36,0,0,1,211,357.77Zm1.92-1.43v-1.15a1,1,0,0,0-.79-.42c-.53,0-.85.42-.85,1s.32,1,.85,1A1,1,0,0,0,213,356.34Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.83,357.1v-.3a1.13,1.13,0,0,1-.87.37.88.88,0,0,1-.92-.87.86.86,0,0,1,.92-.87,1.1,1.1,0,0,1,.87.35v-.47c0-.35-.28-.55-.67-.55a1,1,0,0,0-.8.36l-.19-.28a1.38,1.38,0,0,1,1.05-.43c.56,0,1,.25,1,.88v1.81Zm0-.55v-.5a.88.88,0,0,0-.72-.33.58.58,0,1,0,0,1.15A.9.9,0,0,0,215.83,356.55Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M217.06,357.1v-2.63h.41v.42a1.14,1.14,0,0,1,.88-.48v.42h-.16a1,1,0,0,0-.72.42v1.86Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M218.71,355.78a1.3,1.3,0,1,1,1.3,1.39A1.28,1.28,0,0,1,218.71,355.78Zm2.17,0a.88.88,0,1,0-.87,1A.91.91,0,0,0,220.88,355.78Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M221.83,355.78a1.3,1.3,0,1,1,1.3,1.39A1.28,1.28,0,0,1,221.83,355.78Zm2.17,0a.88.88,0,1,0-.87,1A.91.91,0,0,0,224,355.78Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M224.94,355.78a1.31,1.31,0,0,1,1.3-1.37,1.28,1.28,0,0,1,1.27,1.41v.1h-2.13a.92.92,0,0,0,.94.91,1.13,1.13,0,0,0,.82-.34l.2.27a1.46,1.46,0,0,1-1.05.41A1.31,1.31,0,0,1,224.94,355.78Zm1.3-1a.87.87,0,0,0-.86.87h1.72A.84.84,0,0,0,226.24,354.74Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M230.07,357.1v-.39a1.08,1.08,0,0,1-.89.46,1.4,1.4,0,0,1,0-2.76,1.09,1.09,0,0,1,.89.46v-1.4h.41v3.63Zm0-.72V355.2a1,1,0,0,0-.78-.43c-.54,0-.85.44-.85,1s.31,1,.85,1A1,1,0,0,0,230.07,356.38Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M233.08,357.1v-.37a1.31,1.31,0,0,1-.94.44.75.75,0,0,1-.84-.84v-1.86h.41v1.73c0,.47.23.6.59.6a1,1,0,0,0,.78-.4v-1.93h.4v2.63Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M234.22,356.86a.3.3,0,0,1,.3-.3.29.29,0,0,1,.3.3.3.3,0,0,1-.3.3A.31.31,0,0,1,234.22,356.86Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M235.37,355.78a1.29,1.29,0,0,1,1.32-1.37,1.13,1.13,0,0,1,1,.45l-.27.25a.79.79,0,0,0-.67-.34,1,1,0,0,0,0,2,.81.81,0,0,0,.67-.34l.27.25a1.13,1.13,0,0,1-1,.46A1.31,1.31,0,0,1,235.37,355.78Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M238.08,355.78a1.3,1.3,0,1,1,1.3,1.39A1.28,1.28,0,0,1,238.08,355.78Zm2.17,0a.88.88,0,1,0-.87,1A.91.91,0,0,0,240.25,355.78Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M244.52,357.1v-1.78c0-.34-.14-.55-.48-.55a.92.92,0,0,0-.7.4v1.93h-.41v-1.78c0-.34-.13-.55-.48-.55a.92.92,0,0,0-.69.41v1.92h-.41v-2.63h.41v.38a1.13,1.13,0,0,1,.85-.44.66.66,0,0,1,.7.49,1.11,1.11,0,0,1,.89-.49c.48,0,.73.26.73.79v1.9Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 49.23,
    x2: 567.05,
    y2: 49.23
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 392.61,
    x2: 567.05,
    y2: 392.61
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 0.12,
    x2: 0.13,
    y2: 392.61
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 343.51,
    y1: 0.12,
    x2: 343.51,
    y2: 392.61
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 34.46,
    y1: 0.12,
    x2: 34.46,
    y2: 392.61
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 68.8,
    y1: 0.12,
    x2: 68.8,
    y2: 392.61
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 103.14,
    y1: 0.12,
    x2: 103.14,
    y2: 392.61
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 137.48,
    y1: 0.12,
    x2: 137.48,
    y2: 392.61
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 171.82,
    y1: 0.12,
    x2: 171.82,
    y2: 392.61
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 206.16,
    y1: 0.12,
    x2: 206.16,
    y2: 392.61
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 240.49,
    y1: 0.12,
    x2: 240.49,
    y2: 392.61
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 274.83,
    y1: 0.12,
    x2: 274.83,
    y2: 392.61
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 309.17,
    y1: 0.12,
    x2: 309.17,
    y2: 392.61
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 17.29,
    y1: 0.12,
    x2: 17.29,
    y2: 392.61
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 51.63,
    y1: 0.12,
    x2: 51.63,
    y2: 392.61
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 85.97,
    y1: 0.12,
    x2: 85.97,
    y2: 392.61
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 120.31,
    y1: 0.12,
    x2: 120.31,
    y2: 392.61
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 154.65,
    y1: 0.12,
    x2: 154.65,
    y2: 392.61
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 188.99,
    y1: 0.12,
    x2: 188.99,
    y2: 392.61
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 223.33,
    y1: 0.12,
    x2: 223.33,
    y2: 392.61
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 257.66,
    y1: 0.12,
    x2: 257.66,
    y2: 392.61
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 292,
    y1: 0.12,
    x2: 292,
    y2: 392.61
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 326.34,
    y1: 0.12,
    x2: 326.34,
    y2: 392.61
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 358.28,
    x2: 567.05,
    y2: 358.28
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 323.94,
    x2: 567.05,
    y2: 323.94
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 289.6,
    x2: 567.05,
    y2: 289.6
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 255.26,
    x2: 567.05,
    y2: 255.26
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 220.92,
    x2: 567.05,
    y2: 220.92
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 186.58,
    x2: 567.05,
    y2: 186.58
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 152.24,
    x2: 567.05,
    y2: 152.24
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 117.91,
    x2: 567.05,
    y2: 117.91
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 83.57,
    x2: 567.05,
    y2: 83.57
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 375.45,
    x2: 567.05,
    y2: 375.45
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 341.11,
    x2: 567.05,
    y2: 341.11
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 306.77,
    x2: 567.05,
    y2: 306.77
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 272.43,
    x2: 567.05,
    y2: 272.43
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 238.09,
    x2: 567.05,
    y2: 238.09
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 203.75,
    x2: 567.05,
    y2: 203.75
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 169.41,
    x2: 567.05,
    y2: 169.41
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 135.08,
    x2: 567.05,
    y2: 135.08
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 100.74,
    x2: 567.05,
    y2: 100.74
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 66.4,
    x2: 567.05,
    y2: 66.4
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 377.85,
    y1: 0.12,
    x2: 377.85,
    y2: 392.61
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 412.19,
    y1: 0.12,
    x2: 412.19,
    y2: 392.61
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 446.53,
    y1: 0.12,
    x2: 446.53,
    y2: 392.61
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 480.86,
    y1: 0.12,
    x2: 480.86,
    y2: 392.61
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 515.2,
    y1: 0.12,
    x2: 515.2,
    y2: 392.61
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 549.54,
    y1: 0.12,
    x2: 549.54,
    y2: 392.61
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 360.68,
    y1: 0.12,
    x2: 360.68,
    y2: 392.61
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 395.02,
    y1: 0.12,
    x2: 395.02,
    y2: 392.61
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 429.36,
    y1: 0.12,
    x2: 429.36,
    y2: 392.61
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 463.7,
    y1: 0.12,
    x2: 463.7,
    y2: 392.61
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 498.03,
    y1: 0.12,
    x2: 498.03,
    y2: 392.61
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 532.37,
    y1: 0.12,
    x2: 532.37,
    y2: 392.61
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 566.71,
    y1: 0.12,
    x2: 566.71,
    y2: 392.61
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 32.06,
    x2: 567.05,
    y2: 32.06
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 14.89,
    x2: 567.05,
    y2: 14.89
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 0.13,
    y: 0.13,
    width: 566.93,
    height: 392.49
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M.49,408.62l.3-.35a2.2,2.2,0,0,0,1.67.78c1.09,0,1.4-.61,1.4-1.07,0-1.56-3.2-.75-3.2-2.61,0-.87.78-1.42,1.75-1.42a2.31,2.31,0,0,1,1.81.75l-.31.33a1.9,1.9,0,0,0-1.52-.67c-.71,0-1.25.41-1.25,1,0,1.36,3.2.61,3.2,2.6,0,.69-.46,1.51-1.9,1.51A2.5,2.5,0,0,1,.49,408.62Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5.31,404.58a.32.32,0,0,1,.64,0,.32.32,0,1,1-.64,0Zm.11,4.79v-3.86h.42v3.86Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M6.93,409.37V409l2.29-3.15H6.93v-.36H9.75v.33L7.44,409H9.79v.37Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.67,407.43a1.91,1.91,0,0,1,1.85-2,1.85,1.85,0,0,1,1.83,2v.11H11.12a1.49,1.49,0,0,0,1.51,1.53,1.71,1.71,0,0,0,1.26-.53l.22.27a2,2,0,0,1-1.52.62A1.9,1.9,0,0,1,10.67,407.43Zm1.84-1.66a1.45,1.45,0,0,0-1.39,1.47h2.8A1.42,1.42,0,0,0,12.51,405.77Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.29,405.8a.36.36,0,0,1,.36-.35.35.35,0,0,1,0,.7A.36.36,0,0,1,15.29,405.8Zm0,3.29a.36.36,0,0,1,.36-.35.35.35,0,0,1,0,.7A.36.36,0,0,1,15.29,409.09Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.92,409.37v-4.71l-.85.91-.28-.3L20,404h.42v5.34Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.3,408.58l.31-.28a1.79,1.79,0,0,0,1.5.75c.82,0,1.34-.43,1.34-1.14s-.63-1.08-1.43-1.08h-.5v-.43H23c.71,0,1.35-.31,1.35-1s-.59-1-1.28-1a1.79,1.79,0,0,0-1.43.68l-.29-.29a2.24,2.24,0,0,1,1.74-.81c.93,0,1.72.51,1.72,1.41a1.29,1.29,0,0,1-1.14,1.25,1.36,1.36,0,0,1,1.22,1.33c0,.88-.66,1.52-1.8,1.52A2.1,2.1,0,0,1,21.3,408.58Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.93,404.58a.31.31,0,0,1,.32-.31.31.31,0,0,1,.32.31.32.32,0,0,1-.32.32A.33.33,0,0,1,25.93,404.58Zm.11,4.79v-3.86h.42v3.86Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30.36,409.37v-2.62c0-.74-.37-1-.93-1a1.66,1.66,0,0,0-1.26.66v2.92h-.42v-3.86h.42v.58a1.94,1.94,0,0,1,1.39-.68c.79,0,1.22.38,1.22,1.26v2.7Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.86,407.43a1.88,1.88,0,0,1,1.87-2,1.59,1.59,0,0,1,1.37.66l-.29.25a1.23,1.23,0,0,0-1.06-.53,1.66,1.66,0,0,0,0,3.3,1.22,1.22,0,0,0,1.06-.55l.29.26a1.59,1.59,0,0,1-1.37.66A1.88,1.88,0,0,1,31.86,407.43Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.63,409.37v-2.63c0-.75-.37-.95-.93-.95a1.66,1.66,0,0,0-1.26.66v2.92H36V404h.41v2.06a1.94,1.94,0,0,1,1.39-.68,1.08,1.08,0,0,1,1.22,1.24v2.72Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40.13,407.43a1.91,1.91,0,0,1,1.86-2,1.85,1.85,0,0,1,1.82,2v.11H40.58a1.5,1.5,0,0,0,1.51,1.53,1.68,1.68,0,0,0,1.26-.53l.22.27a2,2,0,0,1-1.51.62A1.9,1.9,0,0,1,40.13,407.43ZM42,405.77a1.45,1.45,0,0,0-1.4,1.47h2.81A1.42,1.42,0,0,0,42,405.77Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.55,408.85l.24-.31a1.6,1.6,0,0,0,1.25.57c.65,0,1-.33,1-.78,0-1.06-2.44-.46-2.44-1.85,0-.59.51-1.07,1.38-1.07a1.78,1.78,0,0,1,1.38.57l-.23.29a1.41,1.41,0,0,0-1.15-.51c-.6,0-1,.31-1,.71,0,1,2.43.37,2.43,1.86,0,.62-.48,1.13-1.45,1.13A1.84,1.84,0,0,1,44.55,408.85Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M53.18,409.37l-1.28-1.71-1.29,1.71h-.49l1.52-2-1.44-1.88h.5l1.2,1.59,1.19-1.59h.49l-1.43,1.88,1.52,2Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M56.61,408.78l.27-.33a1.37,1.37,0,0,0,1.17.59c1.17,0,1.57-1.22,1.57-2.34v-.25a2,2,0,0,1-1.56.89,1.58,1.58,0,0,1-1.72-1.69,1.7,1.7,0,0,1,1.79-1.7c1.44,0,2,1.32,2,2.76s-.57,2.75-2,2.75A1.7,1.7,0,0,1,56.61,408.78Zm3-2.76c-.06-.73-.44-1.66-1.44-1.66a1.29,1.29,0,0,0-1.35,1.28,1.22,1.22,0,0,0,1.34,1.29A1.75,1.75,0,0,0,59.59,406Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.09,404.58a.31.31,0,0,1,.32-.31.31.31,0,0,1,.32.31.32.32,0,0,1-.32.32A.33.33,0,0,1,61.09,404.58Zm.11,4.79v-3.86h.42v3.86Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M65.52,409.37v-2.62c0-.74-.38-1-.93-1a1.66,1.66,0,0,0-1.26.66v2.92h-.42v-3.86h.42v.58a1.94,1.94,0,0,1,1.39-.68,1.09,1.09,0,0,1,1.22,1.26v2.7Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67,407.43a1.88,1.88,0,0,1,1.87-2,1.59,1.59,0,0,1,1.37.66l-.29.25a1.23,1.23,0,0,0-1.06-.53,1.66,1.66,0,0,0,0,3.3,1.22,1.22,0,0,0,1.06-.55l.29.26a1.59,1.59,0,0,1-1.37.66A1.88,1.88,0,0,1,67,407.43Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.79,409.37v-2.63c0-.75-.37-.95-.93-.95a1.66,1.66,0,0,0-1.26.66v2.92h-.41V404h.41v2.06a1.94,1.94,0,0,1,1.39-.68,1.08,1.08,0,0,1,1.22,1.24v2.72Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.29,407.43a1.91,1.91,0,0,1,1.85-2,1.85,1.85,0,0,1,1.83,2v.11H75.74a1.5,1.5,0,0,0,1.51,1.53,1.69,1.69,0,0,0,1.26-.53l.22.27a2,2,0,0,1-1.51.62A1.9,1.9,0,0,1,75.29,407.43Zm1.85-1.66a1.45,1.45,0,0,0-1.4,1.47h2.8A1.41,1.41,0,0,0,77.14,405.77Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.71,408.85l.24-.31a1.6,1.6,0,0,0,1.25.57c.65,0,1-.33,1-.78,0-1.06-2.44-.46-2.44-1.85,0-.59.51-1.07,1.38-1.07a1.78,1.78,0,0,1,1.38.57l-.23.29a1.41,1.41,0,0,0-1.15-.51c-.6,0-1,.31-1,.71,0,1,2.43.37,2.43,1.86,0,.62-.48,1.13-1.45,1.13A1.84,1.84,0,0,1,79.71,408.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideMaterial4);
export default __webpack_public_path__ + "static/media/guideMaterial4.8911e2ab036e0c8e7dfc6099ba17e5a7.svg";
export { ForwardRef as ReactComponent };